import { render, staticRenderFns } from "./LegalModal-info.vue?vue&type=template&id=1931e526&"
import script from "./LegalModal-info.vue?vue&type=script&lang=js&"
export * from "./LegalModal-info.vue?vue&type=script&lang=js&"
import style0 from "./LegalModal-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports